<template>
  <div class="ac-card-content">
    <div class="delete-vv-header-container">
      <button
        class="ac-close-button"
        @click="toggleActionModal(true, 'edit-visit')"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="delete-vv-header-title">
        Are you sure?
      </div>
    </div>
    <div class="delete-vv-body-container">
      <div class="delete-vv-body-header">
        Delete this virtual visit
      </div>
      <div class="delete-vv-body-info">
        Once deleted, a Virtual Visit will be removed from all accounts. Are you sure?
      </div>
    </div>
    <div class="delete-vv-footer-container">
      <button
        class="delete-vv-footer-cancel-btn"
        @click="toggleActionModal(true, 'edit-visit')"
      >
        Cancel
      </button>
      <button
        class="delete-vv-footer-delete-btn"
        @click="deleteVirtualVisit"
      >
        Delete
      </button>
    </div>
  </div>
</template>
<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';

export default {
  name: 'DeleteVirtualVisit',
  mixins: [customerDetailMixin],
  methods: {
    deleteVirtualVisit() {
      this.$store.dispatch('deleteVirtualVisit');
      this.toggleActionModal(false);
    },
  },
};
</script>
<style lang="scss">

.delete-vv-header-container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;

  .delete-vv-header-title {
    font-size: 24px;
    font-weight: 600;
    margin-left: 10px;
  }

  .ac-close-button {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background-color: $NBLUE10;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: $NBLUE20;
    }

    .ac-close {
      width: 10px;
      height: 10px;
    }
  }
}

.delete-vv-body-container {
  display: flex;
  flex-direction: column;
  padding: 0 20px;

  .delete-vv-body-header {
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .delete-vv-body-info {
    font-size: 16px;
  }
}

.delete-vv-footer-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  margin-top: 25px;

  button:not(:last-child) {
    margin-right: 12px;
  }

  .delete-vv-footer-cancel-btn {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $WHITE;
    border: 1px solid $PRIMARY;
    color: $PRIMARY;
    font-weight: 600;
  }

  .delete-vv-footer-delete-btn {
    padding: 0 16px;
    height: 40px;
    border-radius: 6px;
    background-color: $PUNCH;
    color: $WHITE;
    font-weight: 600;

    &:hover {
      background-color: $PUNCH;
    }
  }
}
</style>
